// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/PostTriggerModal.module.css */

.PostTriggerModal_overlay__AWSY8 {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.PostTriggerModal_modal__OgrUY {
  width: 100%;
  max-width: 720px;
  max-height: 88vh;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ---------------- Header ---------------- */

.PostTriggerModal_header__Rh0Pt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.PostTriggerModal_headerLeft__tSRc\\+ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.PostTriggerModal_backBtn__jyqhE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  color: #4a5568;
}

.PostTriggerModal_backBtn__jyqhE:hover {
  background: #edf2f7;
}

.PostTriggerModal_title__ULabD {
  font-size: 15px;
  font-weight: 600;
  color: #1a202c;
  margin: 0;
}

.PostTriggerModal_closeBtn__ggbY2 {
  background: transparent;
  border: none;
  color: #a0aec0;
  cursor: pointer;
  padding: 4px;
  font-size: 14px;
}

.PostTriggerModal_closeBtn__ggbY2:hover {
  color: #4a5568;
}

/* ---------------- Body ---------------- */

.PostTriggerModal_body__evfHn {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
}

/* Search */
.PostTriggerModal_searchRow__9xlGk {
  position: relative;
  margin-bottom: 14px;
}

.PostTriggerModal_searchIcon__hO0Ln {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #a0aec0;
  pointer-events: none;
}

.PostTriggerModal_searchInput__ZRIwf {
  width: 100%;
  padding: 8px 12px 8px 32px;
  font-size: 13px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  outline: none;
}

.PostTriggerModal_searchInput__ZRIwf:focus {
  border-color: #5b7cfa;
  box-shadow: 0 0 0 3px rgba(91, 124, 250, 0.15);
}

/* Provider groups */
.PostTriggerModal_providerGroup__n5vC5 {
  margin-bottom: 18px;
}

.PostTriggerModal_providerHeader__MHPCl {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 8px;
}

.PostTriggerModal_providerHeaderName__yBni0 {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #4a5568;
}

.PostTriggerModal_providerHeaderWarn__YWMe2 {
  font-size: 11px;
  color: #c05621;
}

.PostTriggerModal_opGrid__-yLCc {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}

.PostTriggerModal_opCard__D9IUx {
  text-align: left;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.PostTriggerModal_opCard__D9IUx:hover:not(:disabled) {
  border-color: #5b7cfa;
  background: #f7f9ff;
}

.PostTriggerModal_opCardDisabled__W1ggf {
  opacity: 0.5;
  cursor: not-allowed;
}

.PostTriggerModal_opCardName__TEtd9 {
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 3px;
}

.PostTriggerModal_opCardKey__5bcMX {
  font-size: 11px;
  color: #5b7cfa;
  margin-bottom: 4px;
}

.PostTriggerModal_opCardKey__5bcMX code {
  background: #ebf0ff;
  padding: 1px 6px;
  border-radius: 4px;
  font-family: monospace;
}

.PostTriggerModal_opCardDesc__ChUZs {
  font-size: 12px;
  color: #718096;
  line-height: 1.4;
}

/* Selected-op bar (params stage) */
.PostTriggerModal_selectedOpBar__tRbab {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 12px;
  background: #f7f9ff;
  border: 1px solid #dbe4ff;
  border-radius: 8px;
  margin-bottom: 14px;
}

.PostTriggerModal_selectedOpName__uuNOA {
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
}

.PostTriggerModal_selectedOpKey__FXtrz {
  font-size: 11px;
  color: #5b7cfa;
  background: #ffffff;
  padding: 1px 6px;
  border-radius: 4px;
  font-family: monospace;
}

.PostTriggerModal_selectedOpWarn__\\+UBlh {
  flex-basis: 100%;
  font-size: 11px;
  color: #c05621;
  padding-top: 4px;
}

/* Field grid */
.PostTriggerModal_fieldGrid__WFSQF {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.PostTriggerModal_fieldRow__XLtQI {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.PostTriggerModal_fieldLabelRow__2m-2- {
  display: flex;
  align-items: center;
  gap: 6px;
}

.PostTriggerModal_fieldLabel__yj0NK {
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
}

.PostTriggerModal_requiredMark__MtH\\+y {
  color: #e53e3e;
  margin-left: 3px;
}

.PostTriggerModal_helpIcon__VS\\+h3 {
  color: #a0aec0;
  cursor: help;
  display: inline-flex;
}

.PostTriggerModal_input__D\\+AU7 {
  width: 100%;
  padding: 8px 12px;
  font-size: 13px;
  font-family: inherit;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  outline: none;
}

.PostTriggerModal_input__D\\+AU7:focus {
  border-color: #5b7cfa;
  box-shadow: 0 0 0 3px rgba(91, 124, 250, 0.15);
}

.PostTriggerModal_booleanRow__I6fgc {
  display: flex;
}

.PostTriggerModal_fieldChips__VyIn2 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.PostTriggerModal_fieldChipsLabel__W\\+MZX {
  font-size: 11px;
  color: #a0aec0;
  align-self: center;
  margin-right: 2px;
}

.PostTriggerModal_fieldChip__NnsCQ {
  font-size: 11px;
  font-family: monospace;
  color: #4a5568;
  background: #edf2f7;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 2px 8px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.PostTriggerModal_fieldChip__NnsCQ:hover {
  background: #dbe4ff;
  border-color: #5b7cfa;
  color: #2c5282;
}

.PostTriggerModal_fieldChipsMore__BrzPr {
  font-size: 11px;
  color: #a0aec0;
  align-self: center;
}

/* Loading / empty */
.PostTriggerModal_loadingBlock__B6JRn,
.PostTriggerModal_emptyBlock__eAhrw {
  padding: 24px 16px;
  font-size: 13px;
  color: #718096;
  text-align: center;
  background: #f7fafc;
  border: 1px dashed #cbd5e0;
  border-radius: 8px;
}

/* ---------------- Footer ---------------- */

.PostTriggerModal_footer__d2qzg {
  border-top: 1px solid #e2e8f0;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.PostTriggerModal_footerError__5FgBw {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #c53030;
}

.PostTriggerModal_footerActions__CXnHm {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.PostTriggerModal_cancelBtn__A-GbT,
.PostTriggerModal_saveBtn__kP59R {
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid transparent;
}

.PostTriggerModal_cancelBtn__A-GbT {
  background: transparent;
  color: #4a5568;
  border-color: #e2e8f0;
}

.PostTriggerModal_cancelBtn__A-GbT:hover {
  background: #f7fafc;
}

.PostTriggerModal_saveBtn__kP59R {
  background: #5b7cfa;
  color: #ffffff;
}

.PostTriggerModal_saveBtn__kP59R:hover:not(:disabled) {
  background: #4a6ce0;
}

.PostTriggerModal_saveBtn__kP59R:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/PostTriggerModal.module.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6CAA6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;;AAE3C;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,6CAA6C;;AAE7C;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* qchat_fe/src/Component/SideData/Overview/AiAgentWorkFlow/PostTriggerModal.module.css */\n\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  z-index: 9998;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.modal {\n  width: 100%;\n  max-width: 720px;\n  max-height: 88vh;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ---------------- Header ---------------- */\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.backBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  background: transparent;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #4a5568;\n}\n\n.backBtn:hover {\n  background: #edf2f7;\n}\n\n.title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a202c;\n  margin: 0;\n}\n\n.closeBtn {\n  background: transparent;\n  border: none;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 4px;\n  font-size: 14px;\n}\n\n.closeBtn:hover {\n  color: #4a5568;\n}\n\n/* ---------------- Body ---------------- */\n\n.body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n}\n\n/* Search */\n.searchRow {\n  position: relative;\n  margin-bottom: 14px;\n}\n\n.searchIcon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #a0aec0;\n  pointer-events: none;\n}\n\n.searchInput {\n  width: 100%;\n  padding: 8px 12px 8px 32px;\n  font-size: 13px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  outline: none;\n}\n\n.searchInput:focus {\n  border-color: #5b7cfa;\n  box-shadow: 0 0 0 3px rgba(91, 124, 250, 0.15);\n}\n\n/* Provider groups */\n.providerGroup {\n  margin-bottom: 18px;\n}\n\n.providerHeader {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.providerHeaderName {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #4a5568;\n}\n\n.providerHeaderWarn {\n  font-size: 11px;\n  color: #c05621;\n}\n\n.opGrid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 8px;\n}\n\n.opCard {\n  text-align: left;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.opCard:hover:not(:disabled) {\n  border-color: #5b7cfa;\n  background: #f7f9ff;\n}\n\n.opCardDisabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.opCardName {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 3px;\n}\n\n.opCardKey {\n  font-size: 11px;\n  color: #5b7cfa;\n  margin-bottom: 4px;\n}\n\n.opCardKey code {\n  background: #ebf0ff;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-family: monospace;\n}\n\n.opCardDesc {\n  font-size: 12px;\n  color: #718096;\n  line-height: 1.4;\n}\n\n/* Selected-op bar (params stage) */\n.selectedOpBar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 10px 12px;\n  background: #f7f9ff;\n  border: 1px solid #dbe4ff;\n  border-radius: 8px;\n  margin-bottom: 14px;\n}\n\n.selectedOpName {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.selectedOpKey {\n  font-size: 11px;\n  color: #5b7cfa;\n  background: #ffffff;\n  padding: 1px 6px;\n  border-radius: 4px;\n  font-family: monospace;\n}\n\n.selectedOpWarn {\n  flex-basis: 100%;\n  font-size: 11px;\n  color: #c05621;\n  padding-top: 4px;\n}\n\n/* Field grid */\n.fieldGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.fieldRow {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.fieldLabelRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.fieldLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.requiredMark {\n  color: #e53e3e;\n  margin-left: 3px;\n}\n\n.helpIcon {\n  color: #a0aec0;\n  cursor: help;\n  display: inline-flex;\n}\n\n.input {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-family: inherit;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  outline: none;\n}\n\n.input:focus {\n  border-color: #5b7cfa;\n  box-shadow: 0 0 0 3px rgba(91, 124, 250, 0.15);\n}\n\n.booleanRow {\n  display: flex;\n}\n\n.fieldChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.fieldChipsLabel {\n  font-size: 11px;\n  color: #a0aec0;\n  align-self: center;\n  margin-right: 2px;\n}\n\n.fieldChip {\n  font-size: 11px;\n  font-family: monospace;\n  color: #4a5568;\n  background: #edf2f7;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 2px 8px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.fieldChip:hover {\n  background: #dbe4ff;\n  border-color: #5b7cfa;\n  color: #2c5282;\n}\n\n.fieldChipsMore {\n  font-size: 11px;\n  color: #a0aec0;\n  align-self: center;\n}\n\n/* Loading / empty */\n.loadingBlock,\n.emptyBlock {\n  padding: 24px 16px;\n  font-size: 13px;\n  color: #718096;\n  text-align: center;\n  background: #f7fafc;\n  border: 1px dashed #cbd5e0;\n  border-radius: 8px;\n}\n\n/* ---------------- Footer ---------------- */\n\n.footer {\n  border-top: 1px solid #e2e8f0;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.footerError {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #c53030;\n}\n\n.footerActions {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.cancelBtn,\n.saveBtn {\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.cancelBtn {\n  background: transparent;\n  color: #4a5568;\n  border-color: #e2e8f0;\n}\n\n.cancelBtn:hover {\n  background: #f7fafc;\n}\n\n.saveBtn {\n  background: #5b7cfa;\n  color: #ffffff;\n}\n\n.saveBtn:hover:not(:disabled) {\n  background: #4a6ce0;\n}\n\n.saveBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `PostTriggerModal_overlay__AWSY8`,
	"modal": `PostTriggerModal_modal__OgrUY`,
	"header": `PostTriggerModal_header__Rh0Pt`,
	"headerLeft": `PostTriggerModal_headerLeft__tSRc+`,
	"backBtn": `PostTriggerModal_backBtn__jyqhE`,
	"title": `PostTriggerModal_title__ULabD`,
	"closeBtn": `PostTriggerModal_closeBtn__ggbY2`,
	"body": `PostTriggerModal_body__evfHn`,
	"searchRow": `PostTriggerModal_searchRow__9xlGk`,
	"searchIcon": `PostTriggerModal_searchIcon__hO0Ln`,
	"searchInput": `PostTriggerModal_searchInput__ZRIwf`,
	"providerGroup": `PostTriggerModal_providerGroup__n5vC5`,
	"providerHeader": `PostTriggerModal_providerHeader__MHPCl`,
	"providerHeaderName": `PostTriggerModal_providerHeaderName__yBni0`,
	"providerHeaderWarn": `PostTriggerModal_providerHeaderWarn__YWMe2`,
	"opGrid": `PostTriggerModal_opGrid__-yLCc`,
	"opCard": `PostTriggerModal_opCard__D9IUx`,
	"opCardDisabled": `PostTriggerModal_opCardDisabled__W1ggf`,
	"opCardName": `PostTriggerModal_opCardName__TEtd9`,
	"opCardKey": `PostTriggerModal_opCardKey__5bcMX`,
	"opCardDesc": `PostTriggerModal_opCardDesc__ChUZs`,
	"selectedOpBar": `PostTriggerModal_selectedOpBar__tRbab`,
	"selectedOpName": `PostTriggerModal_selectedOpName__uuNOA`,
	"selectedOpKey": `PostTriggerModal_selectedOpKey__FXtrz`,
	"selectedOpWarn": `PostTriggerModal_selectedOpWarn__+UBlh`,
	"fieldGrid": `PostTriggerModal_fieldGrid__WFSQF`,
	"fieldRow": `PostTriggerModal_fieldRow__XLtQI`,
	"fieldLabelRow": `PostTriggerModal_fieldLabelRow__2m-2-`,
	"fieldLabel": `PostTriggerModal_fieldLabel__yj0NK`,
	"requiredMark": `PostTriggerModal_requiredMark__MtH+y`,
	"helpIcon": `PostTriggerModal_helpIcon__VS+h3`,
	"input": `PostTriggerModal_input__D+AU7`,
	"booleanRow": `PostTriggerModal_booleanRow__I6fgc`,
	"fieldChips": `PostTriggerModal_fieldChips__VyIn2`,
	"fieldChipsLabel": `PostTriggerModal_fieldChipsLabel__W+MZX`,
	"fieldChip": `PostTriggerModal_fieldChip__NnsCQ`,
	"fieldChipsMore": `PostTriggerModal_fieldChipsMore__BrzPr`,
	"loadingBlock": `PostTriggerModal_loadingBlock__B6JRn`,
	"emptyBlock": `PostTriggerModal_emptyBlock__eAhrw`,
	"footer": `PostTriggerModal_footer__d2qzg`,
	"footerError": `PostTriggerModal_footerError__5FgBw`,
	"footerActions": `PostTriggerModal_footerActions__CXnHm`,
	"cancelBtn": `PostTriggerModal_cancelBtn__A-GbT`,
	"saveBtn": `PostTriggerModal_saveBtn__kP59R`
};
export default ___CSS_LOADER_EXPORT___;
